export enum Race {
    ASIAN = "Asian",
    BLACK = "Black",
    NATIVE_AMERICAN = "Native American",
    PACIFIC_ISLANDER = "Pacific Islander",
    HISPANIC = "Hispanic",
    WHITE = "White",
    OTHERS = "Others",
    NOT_DISCLOSED = "Not Disclosed",
  }
  
  export enum Gender {
    MALE = "Male",
    FEMALE = "Female",
    REGULAR = "Gender other than male or female",
    NOT_DISCLOSED = "Not Disclosed",
  }
  
  export enum Ranking {
    TOP1 = "Top 1%",
    TOP5 = "Top 5%",
    TOP10 = "Top 10%",
    TOP15 = "Top 15%",
    TOP20 = "Top 20%",
    TOP25 = "Top 25%",
    TOP50 = "Top 50%",
    BOTTOM50 = "Bottom 50%",
    NOT_DISCLOSED = "Not Disclosed",
  }

  export enum Residency_Status {
    Citizen = "U.S. Citizen",
    Permanent = "Permanent Resident",
    International = "International Student on Visa"
  }
